import { Sparkles, Car, Disc3, Waves, Home, Truck } from "lucide-react";
import { CORE_SERVICES } from "@/data/site";
import { Reveal, fadeUp, stagger } from "@/lib/motion";
import { motion } from "framer-motion";
import { AddToEnquiryButton, slugify } from "@/components/site/AddToEnquiryButton";

const ICONS = { Sparkles, Car, Disc3, Waves, Home, Truck };

export const CoreServices = () => {
  return (
    <section id="services" data-testid="core-services" className="relative z-10 bg-[#08090B] py-24 sm:py-28">
      <div className="container-x">
        <Reveal className="mb-14 max-w-2xl">
          <span className="eyebrow mb-4"><span className="h-px w-8 bg-[var(--blue-bright)]" /> Core Services</span>
          <h2 className="font-display text-4xl font-800 leading-tight tracking-tight text-white sm:text-5xl">
            Everything your vehicle needs, done properly.
          </h2>
          <p className="mt-4 text-base text-[var(--muted)]">
            Our original detailing and cleaning services — quick to book, easy to trust.
          </p>
        </Reveal>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
          className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CORE_SERVICES.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div key={s.title} variants={fadeUp} data-testid={`service-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="card-line group relative overflow-hidden rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[var(--blue)]/50">
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[var(--blue)]/10 blur-2xl transition-opacity duration-300 group-hover:opacity-100 opacity-0" />
                <div className="mb-6 grid h-12 w-12 place-items-center rounded-xl border border-[var(--line)] bg-[var(--blue)]/10 text-[var(--blue-bright)]">
                  <Icon size={22} strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-xl font-700 text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[var(--muted)]">{s.desc}</p>
                <div className="mt-5">
                  <AddToEnquiryButton id={`core-${slugify(s.title)}`} name={s.title} />
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
